import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import React from "react";
import {AmountTdWidth} from "../../../Table/Common/AmountTd";
import {CustomFieldHelper} from "../../../../shared/CustomFieldHelper";
import {Helper} from "../../../../containers/AppPage/Reports/Ledger/helper";

function getColumns(props, fields) {
    const { currencySymbol } = props;
    return [
        {
            key: 'date',
            dataKey: 'date',
            title: t`Date`,
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderDate,
        },
        {
            key: 'number',
            dataKey: 'number',
            title: t`No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber,
        },
        {
            key: 'type',
            dataKey: 'type',
            title: t`Type`,
            width: 70,
            flexGrow: 16,
            cellRenderer: Helper.renderType,
        },
        {
            key: 'contact_name',
            dataKey: 'contact_name',
            title: t`Contact`,
            width: 0,
            flexGrow: 15,
            cellRenderer: Helper.renderContact,
        },
        {
            title: t`Contact Code`,
            key: 'contact_code',
            cellRenderer: Helper.renderContactCode,
            width: 0,
            flexGrow: 15,
        },
        {
            key: 'number2',
            dataKey: 'number2',
            title: t`Reference No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber2,

        },
        {
            key: 'title',
            dataKey: 'title',
            title: t`Title`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderTitle,
        },
        {
            key: 'description',
            dataKey: 'description',
            title: t`Description`,
            width: 0,
            flexGrow: 17,
            cellRenderer: Helper.renderDescription,
        },
        {
            key: 'payment_method_name',
            dataKey: 'payment_method_name',
            title: t`Payment Method`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderPaymentMethod,
        },
        {
            key: 'base_amount',
            dataKey: 'base_amount',
            title: t`Amount`,
            align: 'right',
            width: AmountTdWidth,
            flexGrow: 14,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.base_amount, currencySymbol),
        },

        // custom fields
        ...CustomFieldHelper.getColumnsBaseTable(fields.transaction),

        {
            key: 'creator',
            dataKey: 'creator',
            title: t`Creator`,
            width: 0,
            flexGrow: 15,
            cellRenderer: ({ rowData }) => (
                <div className="BaseTable__row-cell-text">
                    {rowData.creator || '-'}
                </div>
            ),
        },
    ];
}

export default {
    storageKey: StorageKey.report_transaction_list,
    getReportLabel: () => t`Transaction List`,
    required: [
        'date',
        'number',
        'base_amount',
    ],
    defaulto: [
        'type',
        'contact_name',
        'description',
    ],
    getColumns,
};
